import { Checkbox, FormControlLabel } from '@mui/material';

import { CardCheckStyle } from './card-check-style';
// import { BodyText } from '../typography/typography';

export interface ICardCheck {
  children: React.ReactNode;
  active: boolean;
  // handleChange: () => void;
  dataCy?: string;
  inputRef?: React.Ref<any>;
  name?: string;
}

const CardCheck: React.FC<ICardCheck> = ({ children, active, dataCy, inputRef, ...props }) => {
  return (
    <CardCheckStyle ref={inputRef} tabIndex={0} className={active ? 'active' : ''}>
      <div className="card-check-box">
        <FormControlLabel
          control={
            <Checkbox
              data-cy={dataCy}
              checked={active}
              // onChange={() => handleChange()}
              name="checkedB"
              color="primary"
              inputProps={{ 'aria-label': props.name }}
              {...props}
            />
          }
          label={children}
        />
      </div>
    </CardCheckStyle>
  );
};

export default CardCheck;
